var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDataProvider, useNotify, useUpdate } from "react-admin";
import { useTranslation } from "react-i18next";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import DeleteIcon from "@mui/icons-material/Delete";
import { ListItemIcon, MenuItem, MenuList, Popover } from "@mui/material";
import { Dialog } from "@sequentech/ui-essentials";
import { getSlateName } from "@sequentech/ui-core";
import { MenuStyles, TreeMenuItemContainer } from "@/components/styles/Menu";
import { readSlatesConfig, removeSlate, writeSlatesConfig } from "@/utils/slates";
import { createSlatePath, slatePath } from "@/resources/Slate/slatePaths";
import { useActionPermissions } from "../use-tree-menu-hook";
var SlateTreeItem = function (_a) {
    var election = _a.election, slate = _a.slate, name = _a.name, canRemove = _a.canRemove;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var navigate = useNavigate();
    var notify = useNotify();
    var dataProvider = useDataProvider();
    var update = useUpdate()[0];
    var menuItemRef = useRef(null);
    var _c = useState(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var _d = useState(false), isConfirmOpen = _d[0], setIsConfirmOpen = _d[1];
    var isRtl = i18n.dir(i18n.language) === "rtl";
    var to = slatePath(election.id, slate.id);
    var remove = function () { return __awaiter(void 0, void 0, void 0, function () {
        var current, config, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, dataProvider.getOne("sequent_backend_election", { id: election.id })];
                case 1:
                    current = (_a.sent()).data;
                    config = readSlatesConfig(current.annotations);
                    if (!config) {
                        throw new Error(t("slateScreen.messages.unreadable"));
                    }
                    return [4 /*yield*/, update("sequent_backend_election", {
                            id: election.id,
                            data: {
                                annotations: writeSlatesConfig(current.annotations, removeSlate(config, slate.id)),
                            },
                            previousData: current,
                        }, { mutationMode: "pessimistic", returnPromise: true })];
                case 2:
                    _a.sent();
                    notify(t("sideMenu.menuActions.messages.notification.success.delete"), {
                        type: "success",
                    });
                    navigate("/sequent_backend_election/".concat(election.id));
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    notify(t("sideMenu.menuActions.messages.notification.error.delete"), { type: "error" });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsxs(TreeMenuItemContainer, { ref: menuItemRef, isClicked: !!anchorEl, children: [_jsx(MenuStyles.TreeMenuIconContaier, { isActive: true, onClick: function () { return navigate(to); }, children: _jsx(ChevronRightIcon, { className: "menu-item-collapsed", style: { transform: isRtl ? "rotate(180deg)" : "rotate(0)" } }) }), _jsx(MenuStyles.StyledSideBarNavLink, { title: name, end: true, className: function (_a) {
                            var isActive = _a.isActive;
                            return (isActive ? "active menu-item-slate" : "");
                        }, to: to, style: { textAlign: isRtl ? "end" : "start" }, children: _jsx(MenuStyles.ItemContainer, { children: _jsx(MenuStyles.SpanContainer, { children: name }) }) }), _jsx(MenuStyles.MenuActionContainer, { className: "menu-actions-slate", children: canRemove && (_jsx(MenuStyles.StyledIconContainer, { onClick: function () { return setAnchorEl(menuItemRef.current); }, children: _jsx(MoreHorizIcon, { id: "MoreHorizIcon" }) })) })] }), _jsx(Popover, { open: !!anchorEl, anchorEl: anchorEl, onClose: function () { return setAnchorEl(null); }, anchorOrigin: { vertical: "bottom", horizontal: "right" }, children: _jsx(MenuList, { dense: true, children: _jsxs(MenuItem, { dir: i18n.dir(i18n.language), className: "menu-action-delete-slate", onClick: function () {
                            setAnchorEl(null);
                            setIsConfirmOpen(true);
                        }, children: [_jsx(ListItemIcon, { children: _jsx(DeleteIcon, { color: "error" }) }), t("sideMenu.menuActions.remove.slate")] }) }) }), _jsx(Dialog, { variant: "warning", open: isConfirmOpen, ok: String(t("common.label.delete")), cancel: String(t("common.label.cancel")), title: String(t("common.label.warning")), handleClose: function (result) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                setIsConfirmOpen(false);
                                if (!result) return [3 /*break*/, 2];
                                return [4 /*yield*/, remove()];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                }); }, children: t("sideMenu.menuActions.messages.confirm.delete") })] }));
};
/** The slates of an election in the tree, before its contests. */
export var SlateTreeLeaves = function (_a) {
    var _b, _c;
    var election = _a.election, isArchivedElectionEvents = _a.isArchivedElectionEvents;
    var _d = useTranslation(), t = _d.t, i18n = _d.i18n;
    var _e = useActionPermissions(), canReadElection = _e.canReadElection, canWriteElection = _e.canWriteElection;
    var config = readSlatesConfig(election.annotations);
    var isRtl = i18n.dir(i18n.language) === "rtl";
    if (!config || !canReadElection) {
        return null;
    }
    var presentation = election.presentation;
    var defaultLanguage = (_c = (_b = presentation === null || presentation === void 0 ? void 0 : presentation.language_conf) === null || _b === void 0 ? void 0 : _b.default_language_code) !== null && _c !== void 0 ? _c : undefined;
    var canChange = canWriteElection && !isArchivedElectionEvents;
    return (_jsxs(MenuStyles.TreeLeavesContainer, { children: [config.slates.map(function (slate) { return (_jsx(SlateTreeItem, { election: election, slate: slate, name: getSlateName(slate, i18n.language, defaultLanguage), canRemove: canChange }, slate.id)); }), canChange && (_jsxs(MenuStyles.CreateElectionContainer, { style: { justifyContent: isRtl ? "end" : "start" }, children: [_jsx(MenuStyles.StyledAddIcon, { style: { display: isRtl ? "none" : "block" } }), _jsx(MenuStyles.StyledNavLink, { className: "sequent_backend_slate", to: createSlatePath(election.id), style: { textAlign: isRtl ? "end" : "start" }, children: t("createResource.slate") }), _jsx(MenuStyles.StyledAddIcon, { style: { display: isRtl ? "block" : "none" } }), _jsx(MenuStyles.StyledHiddenDiv, {})] }))] }));
};
